import FiguresTooltip from '../FiguresTooltip';
import { Tooltip } from 'antd';
import { useSelector } from 'react-redux';

const formatDate = date => {
    if (!date) return '';
    return new Date(date).toLocaleDateString('ru-RU');
};

const Perforation = props => {
    const { research, scale, minDepth, width, date, title, toDepth } = props;
    const perforation = useSelector(state => state.displaySettings.colors.perforation);

    const { perforatingDate } = research;

    const bottom = toDepth(research.bottom);
    const roof = toDepth(research.roof);

    return (
        <Tooltip
            title={
                <FiguresTooltip
                    title={title}
                    roof={roof}
                    bottom={bottom}
                    date={date}
                    perforatingDate={formatDate(perforatingDate)}
                    type={'perforation'}
                />
            }
            styles={{ root: { maxWidth: 'none' } }}
        >
            <svg
                width={width}
                height={(bottom - roof) * scale}
                style={{
                    position: 'absolute',
                    left: 1,
                    transform: `translateY(${Math.abs((minDepth - roof - 1) * scale)}px)`,
                }}
                viewBox={`0 0 ${width} ${(bottom - roof) * scale}`}
            >
                <line stroke={perforation} x1="0" y1="1" x2={width * 0.7} y2="1" strokeWidth="2" />
                <line stroke={perforation} x1="1" y1="0" x2="1" y2={(bottom - roof) * scale} strokeWidth="2" />
                <line
                    stroke={perforation}
                    x1={0}
                    y1={(bottom - roof) * scale - 1}
                    x2={width * 0.7}
                    y2={(bottom - roof) * scale - 1}
                    strokeWidth="2"
                />
            </svg>
        </Tooltip>
    );
};

export default Perforation;
